<template>
  <div class="transportation-accounts-purchases">
    <form @submit.prevent="searchTransactions">
      <div class="justify-space-between align-center layout">
        <div>
          <v-btn v-if="isSuperAdmin" @click="openAdHocRevenueDialog" :disabled="apiInProgress">
            <v-icon left>fal fa-badge-dollar</v-icon> Submit Ad Hoc Revenue
          </v-btn> &nbsp;
          <v-btn v-if="isAdmin" @click="goToPayout" :disabled="apiInProgress">
            <v-icon left>fal fa-envelope-open-dollar</v-icon> Payout current trip results
          </v-btn>
        </div>
      </div>
      <v-layout row wrap>
        <v-flex sm2 pa-2>
          <v-select
            :disabled="apiInProgress"
            clearable
            :items="[{ text: 'Already paid out', value: 'onlypaid' }, { text: 'Pending payout', value: 'pendingpaid' }]"
            label="Payout filter"
            class="v-select--fixed-width"
            v-model="selectedPaidFilter"
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex sm2 pa-2>
          <v-select
            :disabled="apiInProgress"
            clearable
            :items="logTypeFilterOptions"
            label="Log Type"
            class="v-select--fixed-width"
            v-model="selectedLogType"
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex sm3 pa-2>
          <transportation-profile-autocomplete
            v-model="selectedVehicles"
            label="Vehicles"
            placeholder="Search by licence plate"
            :disabled="apiInProgress"
            :multi-select="true"
            :transportation-owner-id="currentSelectedAccount ? currentSelectedAccount.id : null"
            :show-owner-account="!currentSelectedAccount"
            :show-recent-when-empty="true"
            :recent-profiles-limit="20"
            @input="onFilterByVehicle"
            clearable
          />
        </v-flex>
        <v-flex sm4>
          <v-layout>
            <v-flex xs6 pa-2>
              <st-date-field
                id="transportation-revenue-date-from"
                v-model="dateFrom"
                label="From"
                to-date-id="transportation-revenue-date-to"
              />
            </v-flex>
            <v-flex xs6 pl-2 pa-2>
              <st-date-field
                id="transportation-revenue-date-to"
                v-model="dateTo"
                label="To"
                from-date-id="transportation-revenue-date-from"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm1 pa-2>
          <v-btn small fab :disabled="apiInProgress" @click="searchTransactions"><v-icon small>fal fa-filter</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </form>
    <v-data-table
      :headers="headers"
      :items="transactions"
      :pagination.sync="pagination"
      :total-items="tableTotalItems"
      :hide-actions="!isTotalTransactionsKnown"
      :loading="apiInProgress"
      :rows-per-page-items="[10, 25, 50]"
      @update:pagination="onPagination"
      class="elevation-1"
      must-sort
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{props.item.amountLabel}}
          </td>
          <td class="text-xs-left">
            {{props.item.dateCreatedLabel}}
          </td>
          <td class="text-xs-left">
            <small>{{props.item.logType}}</small>
          </td>
          <td class="text-xs-left">
            <v-chip v-if="props.item.transportationUserTransactionLogId" color="success" text-color="white" small>
              <v-icon small left>fa fa-check-circle</v-icon>
              <small>{{props.item.payoutLabel}}</small>
            </v-chip>
            <span v-if="!props.item.transportationUserTransactionLogId">{{props.item.payoutLabel}}</span>
          </td>
          <td class="text-xs-left">{{props.item.transportationProfileName}}</td>
          <td class="text-xs-left d-flex justify-start wrap">
            <span v-if="props.item.notesLabel" class="mr-2" v-html="`<small>${props.item.notesLabel}</small>`" />
            <span v-if="isSuperAdmin && props.item.logType === 'ad_hoc_revenue' && props.item.id && !props.item.transportationUserTransactionLogId">
              <v-btn flat icon @click="updateAdHocRevenueDialog(props.item)"><v-icon small>fa fa-pencil</v-icon></v-btn>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="!isTotalTransactionsKnown" class="layout row justify-space-between align-center pa-3">
      <div class="layout row justify-end align-center" style="width: 100%;">
        <small class="pr-2">Page {{ Number(pagination.page) }}</small>
        <v-btn icon :disabled="!canGoToPreviousPage" @click="goToPreviousPage">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!canGoToNextPage" @click="goToNextPage">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </div>
    </div>
    <ad-hoc-revenue-dialog
      v-model="adhocRevenueDialog"
      :signed-in-user="signedInUser"
      :initial-revenue="adhocRevenue"
      :transportation-owner-id="currentSelectedAccount && currentSelectedAccount.id"
      @saved="searchTransactions"
    />
  </div>
</template>

<script>
import src from './src'
export default src
</script>
